import { Box } from "@chakra-ui/layout";
import { BookCarousel } from "../BookCarousel/BookCarousel";
import { useClassifications } from "../../api/client";

export const ClassificationList: React.FC = () => {
  const { data: classifications, error } = useClassifications();

  const visibleClassifications =
    classifications?.filter((classification) => classification.books.length > 0) ?? [];

  if (error || !visibleClassifications.length) {
    return null;
  }

  return (
    <>
      {visibleClassifications.map((classification) => (
        <Box
          key={classification.id}
          overflowX={{ base: "clip", sm: "inherit" }}
          marginRight={{ base: "-0.75rem", sm: "0rem" }}
          marginBottom={{ base: "0rem", sm: "-1rem", md: "-3rem" }}
        >
          <BookCarousel
            title={classification.classificationName}
            books={classification.books}
            viewAllPath={`/classifications/${encodeURIComponent(
              classification.classificationName,
            )}`}
          />
        </Box>
      ))}
    </>
  );
};
